import { render, staticRenderFns } from "./AppointmentsItinerary.vue?vue&type=template&id=36a1a3c3"
import script from "./AppointmentsItinerary.vue?vue&type=script&lang=ts"
export * from "./AppointmentsItinerary.vue?vue&type=script&lang=ts"
import style0 from "./AppointmentsItinerary.vue?vue&type=style&index=0&id=36a1a3c3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports